import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { StatesPage } from '../../StatesPage'

export const statesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/states',
  component: StatesPage,
})
